import { useDispatch, useSelector } from 'react-redux';
import {
  selectOutreachesList,
  selectOutreachesListLoading,
} from '@/store/outreaches/selectors';
import { useEffect } from 'react';
import { fetchAllOutreachesList } from '@/store/outreaches/actions';
// import { statusConfig } from '../../details/projectDetailsConstants';
import {
  useArchiveProjectMutation,
  useCloneProjectMutation,
} from '@/store/query/projects';
import { useParams } from 'react-router-dom';
import {
  getProjectDetails,
  projectDetailsApiActions,
} from '@/store/projectDetails';
import { useKFlags } from '@/hooks/use-k-flags';

export const useProjectActionConfig = (actionKey, selectedCandidates) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const { ats_enabled } = useKFlags();

  const {
    addAction: { isLoading: isAddLoading },
    removeAction: { isLoading: isRemoveLoading },
    createReview: { isLoading: isCreateReviewLoading },
    projectLimitedData: {
      isLoading: isProjectsLoading,
      data: { projects: projectsData = [] } = {},
    },
  } = useSelector(getProjectDetails);

  const flowOptions = useSelector(selectOutreachesList);
  const isFlowOptionsLoading = useSelector(selectOutreachesListLoading);

  //todo: need to show all users or project users - need to confirm
  // for now showing all users
  const reviewOptions = [];

  const [cloneProject, { isLoading: isCloneLoading }] =
    useCloneProjectMutation();

  const [archiveProject, { isLoading: isArchiveLoading }] =
    useArchiveProjectMutation();

  useEffect(() => {
    if (actionKey === 'review') {
      //todo: do api call to get the users here
    }
    if (actionKey === 'flow') {
      //todo: do api call to get all the flows
      dispatch(fetchAllOutreachesList());
    }
    if (actionKey === 'add') {
      dispatch(projectDetailsApiActions('fetchProjectWithLimitedData'));
    }
  }, [actionKey, dispatch]);

  // todo: check for success and error message copy from product
  const actionConfigs = {
    remove: {
      title: 'Remove from project',
      description:
        'Are you sure, the candidate will be permanently removed from this project?',
      successButtonText: 'Remove from project',
      placeholder: 'Type "REMOVE" to confirm',
      validator: (val) => val === 'REMOVE',
      isActionLoading: isRemoveLoading,
      actionSuccessMessage: ' Candidates has been removed from the project',
      apiConfig: {
        urlPath: 'remove_prospect',
        apiAction: 'removeProspectsFromProject',
        contactField: 'contacts',
      },
    },
    clone: {
      title: 'Clone Project',
      description:
        'Create a new project with all the candidates of the current project.',
      successButtonText: 'Clone Project',
      placeholder: 'Type new project name - Min 3 characters',
      validator: (val) => val.length >= 3,
      isActionLoading: isCloneLoading,
      queryAction: cloneProject,
      actionSuccessMessage: 'Project Cloned Successfully',
      actionErrorMessage: 'Cloning the project failed',
    },
    archive: {
      title: 'Archive this project',
      description:
        'If you archive a project it will be permanently blocked and everyone will lose access to it.',
      successButtonText: 'Archive',
      placeholder: 'Type "ARCHIVE" to confirm',
      validator: (val) => val === 'ARCHIVE',
      isActionLoading: isArchiveLoading,
      queryAction: archiveProject,
      actionSuccessMessage: 'Project Archived',
      actionErrorMessage: 'Archiving the project failed',
      buttonColor: '#da5032',
    },
    // todo: enable if needed in future
    // status: {
    //   title: 'Update Status',
    //   successButtonText: 'Change Status',
    //   placeholder: 'Select a status to update',
    //   searchTitle: 'Select Status',
    //   renderType: 'select',
    //   options: statusConfig,
    //   isLoading: false,
    //   validator: (val) => (val ? true : false),
    // },
    add: {
      title: 'Add to project',
      description: 'Add users to different project',
      successButtonText: 'Add to project',
      placeholder: 'Search for projects',
      searchTitle: 'Select projects',
      isActionLoading: isAddLoading,
      isMulti: false,
      renderType: 'select',
      options: projectsData?.filter((pro) => pro?.id !== parseInt(projectId)),
      isLoading: isProjectsLoading,
      validator: (val) => (val ? true : false),
      actionSuccessMessage:
        selectedCandidates.length === 1
          ? 'Candidate has been added to the project'
          : ' Candidates has been added to the project',
      apiConfig: {
        urlPath: 'add_prospect',
        apiAction: 'addProspectsToProject',
        contactField: 'contacts',
      },
    },
    review: {
      title: ats_enabled ? 'Request Review' : 'Send for review',
      description:
        "Your teammate will receive an email with a link to review the candidate's profile.",
      successButtonText: 'Send for review',
      searchTitle: 'Select Users',
      isMulti: true,
      placeholder: 'Search for users',
      renderType: 'requestReview',
      actionSuccessMessage:
        selectedCandidates.length === 1
          ? 'Review requested Successfully'
          : 'Reviews requested Successfully',
      actionErrorMessage: 'Request review - failed',
      options: reviewOptions,
      isLoading: false,
      isActionLoading: isCreateReviewLoading,
      validator: (val) => val,
      apiConfig: {
        urlPath: 'create_review',
        apiAction: 'createReview',
        contactField: 'prospect_ids',
      },
    },
    flow: {
      title: 'Add to Flow',
      description: 'Add users to Flow',
      successButtonText: 'Add to Flow',
      placeholder: 'Search for Flows',
      searchTitle: 'Select Flow',
      isMulti: false,
      renderType: 'select',
      options: flowOptions,
      isLoading: isFlowOptionsLoading,
      validator: (val) => (val ? true : false),
    },
    remove_member: {
      title: 'Remove member',
      description: 'Are you sure you want to remove the user from the project?',
      successButtonText: 'Remove member',
      placeholder: 'Type "REMOVE" to confirm',
      validator: (val) => val === 'REMOVE',
    },
    transfer_ownership: {
      title: 'Transfer ownership',
      description:
        'You will lose admin access to the project. Are you sure you want to change the project owner?',
      successButtonText: 'Change ownership',
      placeholder: 'Type "TRANSFER" to confirm',
      validator: (val) => val === 'TRANSFER',
    },
  };

  return actionConfigs[actionKey] || {};
};
